import React from "react";
import { LoaderIcon, LoaderInner, LoaderMain, LoaderMessage, LoaderPadding } from "./style";

const Loader = ({ message, show = false }) => {
    if (show) {
        return (
            <LoaderMain>
                <LoaderPadding>
                    <LoaderInner>
                        <LoaderIcon>
                            <i className="bx bx-loader-circle bx-spin"/>
                        </LoaderIcon>
                        <LoaderMessage>{message}</LoaderMessage>
                    </LoaderInner>
                </LoaderPadding>
            </LoaderMain>
        );
    }
    return null;
};

export default Loader;